export default {"src":"/_next/static/media/customer-support.a6645eb1.svg","height":30,"width":31,"blurWidth":0,"blurHeight":0};